import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0 py-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Action Needed"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold fs-7" }, "Complete your profile setup")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body d-flex flex-column" }
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = { class: "pt-5" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "text-center fs-6 pb-5 " }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-light-danger fs-8" }, "Notes:"),
  /*#__PURE__*/_createTextVNode("  Current sprint requires stakeholders"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" to approve newly amended policies ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Dropdown1 = _resolveComponent("Dropdown1")
  const _component_apexchart = _resolveComponent("apexchart")

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("button", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown1)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_apexchart, {
          class: "mixed-widget-4-chart",
          options: _ctx.chartOptions,
          series: _ctx.series,
          height: _ctx.chartHeight,
          type: "radialBar"
        }, null, 8, ["options", "series", "height"])
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("a", {
          href: "#",
          class: [`btn-${_ctx.btnColor}`, "btn w-100 py-3"]
        }, "Take Action", 2)
      ])
    ])
  ], 2))
}